import { Button, Form, Select } from "antd";
import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  MantraPIDOPTS,
  MantradeviceInfoAvdm,
  StartekDeviceInfo,
  MorphpoPIDOPTS,
  ToastContainerMsg,
  aadharPattern,
  captureUrl,
  deviceOptions,
  dispatchtoast,
  filterOption,
  getLocalStorageItem,
  handleSubmitForAeps,
  mantrairisPIDOPTS,
  mobilePattern,
  parseXml,
  convertXmlToJson,
  startekPIDOPTS,
  DeviceInfo,
  MantraIrisdeviceInfoAvdm,
} from "../../../../../Utils";
import {
  AepsCashWithdrawl,
  getAllAepsMasters,
  otpcallforaeps,
} from "../../../../../ApiServices/Apifun";
import { xml2json } from "../../../../../Utils/xml2json";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ReportDrawer from "../../../../../Common/ReportDrawer";
import { setselectedTab } from "../../../../../Store/B2bslice";
import CommonInput from "../../../../../Common/CommonInput";
import TwoFaModal from "./TwoFaModal";
import TransactionTwoFaModal from "./TransactionTwoFaModal";
import AepsOtpVerifyModal from "./AepsOtpVerifyModal";
const WithdrawalMoney = () => {
  const [btnLoading, setBtnLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [form] = Form.useForm();
  const formRef = useRef();
  const dispatch = useDispatch();
  const amount = Form.useWatch("amount", form);
  const [openTwoFaModal, setOpenTwoFaModal] = useState(false);
  const [openTransactionTwoFaModal, setTransactionTwoFaModal] = useState(false);
  const [filledData, setFilledData] = useState(null);
  // const [openModal, setOpenModal] = useState(false);
  const [response, setResponse] = useState(null);
  const [otp, setOtp] = useState("");
  const [openOtpModal, setopenotpmodal] = useState(false);
  const [fields, setFields] = useState(null);
  const [TxnOtpReqID, setTxnOtpReqID] = useState(null);
  const [deviceImei, setDeviceImei] = useState("");
  const [openReceiptDrawer, setOpenReceiptDrawer] = useState(false);
  const [userBanks, setUserBanks] = useState([]);
  const [seconds, setSeconds] = useState(180);

  const profiledetail = useSelector((state) => state.B2B.profileDetail);
  const memberServices = useSelector((state) => state.B2B.memberServices);
  // useEffect(() => {
  //   let timer;
  //   let a = 180;
  //   timer = setInterval(() => {
  //     if (a > 0) {
  //       a = a - 1;
  //       setSeconds(a);
  //     } else {
  //       // navigate("/banking/aeps", {
  //       //   state: { from: "/banking/aeps-cash-withdrawl", type: "aeps" },
  //       // }); // Clear the interval when seconds reach 0
  //       // // dispatch(setCashWithdrawalTimer(180));
  //       setOpenTwoFaModal(true)
  //     }
  //   }, 1000);
  //   return () => {
  //     clearInterval(timer);
  //   };
  // }, [openTwoFaModal]);
  useEffect(() => {
    dispatch(setselectedTab("3.2"));
    const handleAepsMasters = () => {
      getAllAepsMasters()
        .then((res) => {
          setUserBanks(
            res.data.user_banks.map((i) => ({
              label: i.bank_name,
              value: i.id,
              key: i.id,
            })),
          );
        })
        .catch((err) => console.log(err));
    };
    handleAepsMasters();
    // if (!location.state?.allow) {
    //   if (memberServices.includes("8")) {
    //     if (
    //       Object.keys(profiledetail).length !== 0 &&
    //       !profiledetail.aeps_onboard
    //     ) {
    //       navigate("/banking/aeps-onboard");
    //     } else if (!profiledetail.ekyc_status) {
    //       navigate("/banking/aeps-ekyc");
    //     } else if (!profiledetail.twofa_status) {
    //       navigate("/banking/aeps", {
    //         state: { from: "/banking/aeps-cash-withdrawl", type: "aeps" },
    //       });
    //     } else {
    //       handleAepsMasters();
    //     }
    //   } else {
    //     navigate("/not-available");
    //   }
    // }
    // else {
    //   handleAepsMasters();
    // }
  }, []);
  const Content = () => {
    return (
      <>
        <div className="border-2 rounded-md w-9/12 border-dashed border-gray-500  ml-4 mr-4 text-center mt-5">
          <p className="-mt-2 bg-white w-[100px] flex justify-center items-center font-semibold m-auto text-[11px]">
            Transaction I'd
          </p>
          <p className="text-[11px] mt-2 mb-2">
            {response?.data?.merchantTransactionId}
          </p>
        </div>
        <div className="text-[10px] border-b-[1px] py-3 border-dashed border-gray-500 w-9/12 text-gray-400 mt-4 ">
          <div className="flex justify-between items-center">
            <p>Merchant Name</p>
            <p className="text-black">{response?.data?.merchant_name}</p>
          </div>
        </div>
        <div className="text-[10px] border-b-[1px] py-3 border-dashed border-gray-500 w-9/12 text-gray-400 mt-4 ">
          <div className="flex justify-between items-center">
            <p>Bank Name</p>
            <p className="text-black">{response?.data?.bank_name}</p>
          </div>
        </div>
        <div className="text-[10px] border-b-[1px] py-3 border-dashed border-gray-500 w-9/12 text-gray-400 mt-4 ">
          <div className="flex justify-between items-center">
            <p>Aadhar Number</p>
            <p className="text-black">{response?.data?.masked_aadhaar}</p>
          </div>
        </div>
        <div className="text-[10px] border-b-[1px] py-3 border-dashed border-gray-500 w-9/12 text-gray-400 mt-4 ">
          <div className="flex justify-between items-center">
            <p>Status</p>
            <p className="text-black">
              {response.data?.status ? "Success" : "Failed"}
            </p>
          </div>
        </div>
        <div className="text-[10px] border-b-[1px] py-3 border-dashed border-gray-500 w-9/12 text-gray-400 mt-4 ">
          <div className="flex justify-between items-center">
            <p>Withdrawl Amount</p>
            <p className="text-black">{filledData?.amount} Rs.</p>
          </div>
        </div>
        <div className="text-[10px] border-b-[1px] py-3 border-dashed border-gray-500 w-9/12 text-gray-400 mt-4 ">
          <div className="flex justify-between items-center">
            <p>Remaining Balance</p>
            <p className="text-black">
              {response?.data?.balanceAmount ?? "0"} Rs.
            </p>
          </div>
        </div>

        <div className="text-[10px] border-b-[1px] py-3 border-dashed border-gray-500 w-9/12 text-gray-400 mt-4 ">
          <div className="flex justify-between items-center">
            <p>Bank RRN</p>
            <p className="text-black">{response?.data?.rrn} Rs.</p>
          </div>
        </div>
        <div className="text-[10px] border-b-[1px] py-3 border-dashed border-gray-500 w-9/12 text-gray-400 mt-4 ">
          <div className="flex justify-between items-center">
            <p>Status</p>
            <p className="text-black">{response?.data?.status}</p>
          </div>
        </div>
      </>
    );
  };
  // var PIDOPTS =
  //   '<PidOptions ver="1.0">' +
  //   '<Opts fCount="1" fType="2" iCount="" iType="" pCount="" pType="" format="0" pidVer="2.0" timeout="10000" env="P" otp="" wadh="" posh=""/>' +
  //   "</PidOptions>";

  // function getPosition(string, subString, index) {
  //   return string.split(subString, index).join(subString).length;
  // }
  const handleDeviceInfo = async (value) => {
    if (value.device === "morpho") {
      let successflag = 0;

      for (let index = 11100; index < 11110; index++) {
        try {
          setBtnLoading(true);

          const res = await axios({
            method: "DEVICEINFO",
            url: `https://localhost:${index}/getDeviceInfo`,
            headers: {
              "Content-Type": "text/xml",
              Accept: "text/xml",
              origin: "https://localhost",
            },
          });

          if (res.status === 200) {
            const xmltojson = convertXmlToJson(res.data);

            const checkDeviceConnection = Object.values(
              xmltojson.attributes,
            ).every((val) => val !== "");

            if (checkDeviceConnection) {
              const deviceImei =
                xmltojson.children[0].children[1].attributes.value;

              const payload = {
                amount: value.amount,
                customer_mobile: value.customer_mobile,
                customer_aadhaar_number: value.customer_aadhaar_number,
                user_bank: value.user_bank.value,
                user_bank_name: value.user_bank.label,
                latitude: getLocalStorageItem("latitude"),
                longitude: getLocalStorageItem("longitude"),
                device_imei: deviceImei,
              };

              const formData = new FormData();

              Object.entries(payload).forEach(([key, val]) =>
                formData.append(key, val),
              );

              const otpRes = await otpcallforaeps(formData);

              if (otpRes.status) {
                setopenotpmodal(true);
                setTxnOtpReqID(otpRes.data.txn_otp_request_id);
                setResponse(otpRes.data);
              }

              successflag = 1;
              break;
            }
          }
        } catch (err) {
          console.log(err);
        } finally {
          setBtnLoading(false);
        }
      }

      if (!successflag) {
        dispatchtoast(
          "Start the service from system services or reconnect device",
          true,
        );
      }
    } else if (value.device === "mantra") {
      MantradeviceInfoAvdm(async (imei) => {
        const payload = {
          amount: value.amount,
          customer_mobile: value.customer_mobile,
          customer_aadhaar_number: value.customer_aadhaar_number,
          user_bank: value.user_bank.value,
          user_bank_name: value.user_bank.label,
          latitude: getLocalStorageItem("latitude"),
          longitude: getLocalStorageItem("longitude"),
          device_imei: imei,
        };

        const formData = new FormData();

        Object.entries(payload).forEach(([key, val]) =>
          formData.append(key, val),
        );

        const otpRes = await otpcallforaeps(formData);

        if (otpRes.status) {
          setopenotpmodal(true);
          setTxnOtpReqID(otpRes.data.txn_otp_request_id);
          setResponse(otpRes.data);
        }
      }, setBtnLoading);
    }

    // Same logic for iris & startek
  };
  const handleSubmit = (formValue) => {
    handleDeviceInfo(formValue);
  };
  return (
    <>
      {/* <div className=" flex justify-end my-3 items-center  text-white">
        <p
          className={`text-right bg-red-600 p-3 rounded-full  cursor-pointer font-semibold ${
            seconds > 0 ? "text-white" : "text-blue-600"
          }`}
        >
          {seconds > 0 ? `2FA valid for ${formatTime(seconds)} sec` : ""}
        </p>
      </div> */}
      <div className="grid grid-cols-1 md:grid-cols-1 place-items-start">
        <div className="prepaid animate-slide-in w-full md:w-1/2 bg-white shadow-normal  rounded-3xl p-5">
          <p className="font-bold text-[15px] mb-2">Cash Withdrawl</p>
          <Form
            ref={formRef}
            name="basic"
            initialValues={{
              remember: true,
            }}
            form={form}
            onFinishFailed={(err) => console.log(err)}
            onFinish={(val) => {
              setFilledData(val);

              if (Number(val.amount) > 5000) {
                setOtp("");
                handleSubmit(val); // This will setOpenOtpModal(true)
              } else {
                setTransactionTwoFaModal(true); // Existing flow
              }
            }}
          >
            <Form.Item
              name={`customer_mobile`}
              label={"Mobile Number"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter Mobile Number!",
                },
                {
                  pattern: mobilePattern,
                  message: "Invalid mobile number format!",
                },
                {
                  whitespace: true,
                  message: "Field cannot contain only blank spaces",
                },
              ]}
            >
              <CommonInput
                placeholder="Enter Your Mobile Number"
                onInput={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  e.target.value = value;
                }}
                name="customer_mobile"
              />
            </Form.Item>
            <Form.Item
              name={`customer_aadhaar_number`}
              label={"Aadhar Number"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter aadhar Number!",
                },
                {
                  pattern: aadharPattern,
                  message: "Invalid aadhar number format!",
                },
                {
                  whitespace: true,
                  message: "Field cannot contain only blank spaces",
                },
              ]}
            >
              <CommonInput
                onInput={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  e.target.value = value;
                }}
                placeholder="Enter Aadhar Number"
                name="customer_aadhaar_number"
              />
            </Form.Item>{" "}
            <Form.Item
              name={`amount`}
              label={"Amount"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter Amount!",
                },
                {
                  whitespace: true,
                  message: "Field cannot contain only blank spaces",
                },
              ]}
            >
              <CommonInput
                placeholder="Enter Amount"
                name="amount"
                onInput={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  e.target.value = value;
                }}
              />
            </Form.Item>
            <Form.Item
              name={`user_bank`}
              label={"Select Bank"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Select one bank!",
                },
              ]}
            >
              <Select
                showSearch
                labelInValue={true}
                placeholder="Select a bank"
                filterOption={filterOption}
                className="w-full mt-2"
                options={userBanks}
              />
            </Form.Item>
            {Number(amount) > 5000 && (
              <Form.Item
                name={`device`}
                label={"Select Device"}
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Select one device!",
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Select Device"
                  filterOption={filterOption}
                  value={fields}
                  onChange={(val) => setFields(val)}
                  className="w-full mt-2"
                  options={deviceOptions}
                />
              </Form.Item>
            )}
            <Form.Item>
              <Button
                loading={btnLoading}
                className="w-full bg-primary border-none mt-4"
                style={{ color: "white" }}
                htmlType="submit"
              >
                Send
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
      {openReceiptDrawer && (
        <ReportDrawer
          title={"Cash Withdrawl Receipt"}
          open={openReceiptDrawer}
          setOpen={setOpenReceiptDrawer}
          content={<Content />}
        />
      )}
      {openOtpModal && (
        <AepsOtpVerifyModal
          setIsOpen={setopenotpmodal}
          isOpen={openOtpModal}
          setTransactionTwoFaModal={setTransactionTwoFaModal}
          openTransactionTwoFaModal={openTransactionTwoFaModal}
          otp={otp}
          setOtp={setOtp}
        />
      )}
      {openTransactionTwoFaModal && (
        <TransactionTwoFaModal
          type={"aeps"}
          form={form}
          setIsOpen={setopenotpmodal}
          setOpenReceiptDrawer={setOpenReceiptDrawer}
          setResponse={setResponse}
          filledData={filledData}
          opentwofa={openTwoFaModal}
          setOpenTwoFaModal={setOpenTwoFaModal}
          opentransactionmodal={openTransactionTwoFaModal}
          setopentransactionModal={setTransactionTwoFaModal}
          otp={otp}
          txn_otp_request_id={TxnOtpReqID}
          setOtp={setOtp}
          selectedDevice={fields}
        />
      )}
    </>
  );
};

export default WithdrawalMoney;
